/* ============================================================
   OXS Audio EU — PDP subnav scroll-spy
   Highlights the link whose target section is currently in view.
   Native anchor jump handles scrolling; CSS scroll-margin-top on the
   target sections offsets for the sticky header + this bar.
   ============================================================ */
(() => {
  const nav = document.querySelector('[data-pdp-subnav]');
  if (!nav) return;
  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;

  const targets = new Map(); // section element -> link
  links.forEach((a) => {
    const id = a.getAttribute('href').slice(1);
    const el = document.getElementById(id);
    if (el) targets.set(el, a);
  });
  if (!targets.size) return;

  const setActive = (link) => {
    links.forEach((l) => l.classList.toggle('is-active', l === link));
  };

  // Clicking a link activates it immediately (before the scroll settles).
  links.forEach((a) => a.addEventListener('click', () => setActive(a)));

  if (!('IntersectionObserver' in window)) return;

  let visible = new Set();
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) visible.add(e.target);
        else visible.delete(e.target);
      });
      // Of the sections currently in view, pick the topmost and light its link.
      let top = null;
      visible.forEach((el) => {
        if (!top || el.getBoundingClientRect().top < top.getBoundingClientRect().top) top = el;
      });
      if (top && targets.has(top)) setActive(targets.get(top));
    },
    { rootMargin: '-140px 0px -55% 0px', threshold: 0 }
  );
  targets.forEach((_link, el) => obs.observe(el));
})();
